<template>
  <v-dialog
    v-model="dialog"
    :class="$options.name"
    persistent
    :width="width"
  >
    <v-card>
      <v-card-title class="title">
        <slot name="title" />
      </v-card-title>

      <v-card-text>
        <slot name="text" />
      </v-card-text>
      <v-card-actions class="px-6">
        <slot name="actions" />

        <template v-if="!$slots.actions">
          <v-btn
            text
            color="success"
            :disabled="disabled"
            @click="onConfirm"
          >
            Подтвердить
          </v-btn>

          <div class="flex-grow-1" />

          <v-btn
            text
            color="grey"
            :disabled="disabled"
            @click="onCancel"
          >
            Отмена
          </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';

export default {
  name: 'confirmation-dialog',

  mixins: [DialogBusMixin],

  props: {
    width: {
      type: String,
      default: '500',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    manualHide: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onConfirm() {
      this.$emit('confirmed');

      if (!this.manualHide) this.dialog = false;
    },

    onCancel() {
      this.$emit('canceled');

      if (!this.manualHide) this.dialog = false;
    },
  },
};

</script>

<style lang="scss" scoped>
  .title {
    word-break: break-word;
  }
</style>
